import {
  PAGES_STATIC_PAGE_SET_DATA,
  PAGES_STATIC_PAGE_RESET_DATA,
} from 'rebook/apps/pages/constants';


const defaultState = {
  title: null,
  content: null,
  pageName3: null,
};

export default function staticPage(state = defaultState, action) {
  switch (action.type) {
    case PAGES_STATIC_PAGE_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case PAGES_STATIC_PAGE_RESET_DATA:
      return defaultState;
    default:
      return state;
  }
}
